import { Actions, createEffect, ofType } from "@ngrx/effects";
import { NotificationActions } from "../actions";
import { delay, filter, map, mergeMap, tap } from "rxjs/operators";
import { Injectable } from "@angular/core";
import { of } from "rxjs";
import { v4 as uuidv4 } from "uuid";
import confetti from "canvas-confetti";

@Injectable()
export class NotificationEffects {
  mapToTriggeredNotification$ = createEffect(() =>
    this.actions.pipe(
      ofType(NotificationActions.notify),
      map((action) =>
        NotificationActions.notificationTriggered({
          triggeredNotification: { ...action.notification, id: uuidv4() },
        }),
      ),
    ),
  );

  clearNotification$ = createEffect(() =>
    this.actions.pipe(
      ofType(NotificationActions.notificationTriggered),
      mergeMap((action) =>
        of(
          NotificationActions.clearNotification({
            notification: action.triggeredNotification,
          }),
        ).pipe(delay(action.triggeredNotification.durationMs)),
      ),
    ),
  );

  showConfetti$ = createEffect(
    () =>
      this.actions.pipe(
        ofType(NotificationActions.notificationTriggered),
        filter(
          (action) => action.triggeredNotification.includeConfetti == true,
        ),
        tap((_) => confetti({ disableForReducedMotion: true })),
      ),
    { dispatch: false },
  );

  constructor(private readonly actions: Actions) {}
}
